import type { ComputedRef } from 'vue'
import { usarCatalogoQuery, usarContextoCatalogo, type EstadoCatalogoQuery } from '@next/compartilhados/catalogos'
import { DESCRITOR_CATALOGO_PERFIL_DE_PERMISSAO, type OpcaoPerfilDePermissao } from '../catalogo-perfil-de-permissao.tipos'
import { usarOperacoesCatalogoPerfilDePermissao } from './catalogo-perfil-de-permissao.injecao'
export const usarCatalogoPerfilDePermissao = (
  habilitado?: ComputedRef<boolean>,
): EstadoCatalogoQuery<OpcaoPerfilDePermissao> => usarCatalogoQuery({
  catalogo: DESCRITOR_CATALOGO_PERFIL_DE_PERMISSAO,
  contexto: usarContextoCatalogo(),
  consultar: usarOperacoesCatalogoPerfilDePermissao().listarOpcoes,
  ...(habilitado ? { habilitado } : {}),
})
